<div class="toggle-container">
  <button 
    [class.selected]="selectedButton === 'left'" 
    (click)="selectButton('left')">{{ leftCaption }}</button>
  <button 
    [class.selected]="selectedButton === 'right'" 
    (click)="selectButton('right')">{{ rightCaption }}</button>
</div>
